import request from '../utils/request'

// 获取角色列表（分页+模糊查询）
export function getRoleList(data) {
  return request({
    url: '/role/page',
    method: 'post',
    data
  })
}

// 根据ID获取角色详情
export function getRoleById(id) {
  return request({
    url: `/role/${id}`,
    method: 'get'
  })
}

// 获取全部角色
export function getAllRoles() {
  return request({
    url: '/role/all',
    method: 'get'
  })
}

// 创建角色
export function createRole(data) {
  return request({
    url: '/role',
    method: 'post',
    data
  })
}

// 更新角色
export function updateRole(data) {
  return request({
    url: '/role',
    method: 'put',
    data
  })
}

// 删除角色
export function deleteRole(id) {
  return request({
    url: `/role/${id}`,
    method: 'delete'
  })
}

// 获取角色菜单
export function getRoleMenus(id) {
  return request({
    url: `/role/${id}/menus`,
    method: 'get'
  })
}

// 更新角色菜单
export function updateRoleMenus(data) {
  return request({
    url: '/role/menus',
    method: 'put',
    data
  })
}